import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TsButtonModule, TSIconModule } from 'tsui';
import { IHeaderParams } from 'ag-grid-community';
import type { IInnerHeaderAngularComp } from 'ag-grid-angular';

export interface ICustomInnerHeaderParams {
  label: string;
  readonly: boolean;
}

@Component({
  selector: 'table-header-renderer',
  standalone: true,
  imports: [MatTooltipModule, TsButtonModule, TSIconModule],
  template: `
    <section class="w-full flex items-center justify-between">
      <p class="mr-2">{{ label }}</p>
      @if (readonly) {
        <ts-icon [matTooltip]="'Read-only field'" [icon]="'ts_lock-alt'" [color]="'black'" [size]="'small'"></ts-icon>
      }
    </section>
  `,
})
export class TsTableHeaderComponent implements IInnerHeaderAngularComp {
  params: IHeaderParams & ICustomInnerHeaderParams;
  label: string;
  readonly: boolean;

  agInit(params: IHeaderParams & ICustomInnerHeaderParams): void {
    this.params = params;
    this.label = params.label;
    this.readonly = params.readonly;
  }

  refresh(params: IHeaderParams) {
    return true;
  }
}
